"use no memo";

import React from 'react';
import classNames from 'classnames';

import styles from './styles.module.scss';

type ButtonLinkProps = {
  children: React.ReactNode;
  className?: string;
  dataTestId?: string;
  disabled?: boolean;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  size?: 'xsmall' | 'small' | 'medium' | 'large';
  secondary?: boolean;
  underline?: boolean;
};

// eslint-disable-next-line import/prefer-default-export
export const ButtonLink: React.FunctionComponent<ButtonLinkProps> = ({
  children,
  className,
  dataTestId,
  disabled = false,
  onClick,
  size = 'medium',
  secondary = false,
  underline = true,
}) => (
  <button
    className={classNames(styles.buttonLink, className, styles[size], {
      [styles.disabled]: disabled,
      [styles.linkSecondary]: secondary,
      [styles.noUnderline]: !underline,
    })}
    type="button"
    tabIndex={0}
    onClick={onClick}
    disabled={disabled}
    data-testid={dataTestId}
  >
    {children}
  </button>
);
